import { __extends, __assign } from 'tslib';
import { ajax } from 'rxjs/ajax';
import { map } from 'rxjs/operators';
import { stringifyUrl, parseUrl } from 'query-string';

function injectAuthHeaders(fullRequestConfig, options, auth) {
    var flyAuth = auth !== null && auth !== void 0 ? auth : options.auth;
    var authHeaders;
    if (flyAuth) {
        authHeaders =
            typeof options.injectAuthHeaders === 'function'
                ? options.injectAuthHeaders(flyAuth, fullRequestConfig)
                : { Authorization: flyAuth };
    }
    if (authHeaders) {
        return __assign(__assign({}, fullRequestConfig), { headers: __assign(__assign({}, fullRequestConfig.headers), authHeaders) });
    }
    return fullRequestConfig;
}
function makeUrl(url, options, queryParams) {
    var _a;
    var fullUrl = ((_a = options.baseUrl) !== null && _a !== void 0 ? _a : '') + options.url + url;
    var _b = parseUrl(fullUrl), cleanUrl = _b.url, query = _b.query;
    if (options.queryParams) {
        query = __assign(__assign({}, options.queryParams), query);
    }
    if (queryParams) {
        query = __assign(__assign({}, query), queryParams);
    }
    if (options.trailingSlash &&
        cleanUrl.length > 0 &&
        cleanUrl[cleanUrl.length - 1] !== '/') {
        cleanUrl += '/';
    }
    return stringifyUrl({ url: cleanUrl, query: query });
}
function guessContentType(body) {
    var fd = typeof window === 'object' ? window.FormData : null;
    if (fd && body instanceof fd) {
        return null;
    }
    return 'application/json';
}
function sendHttp(_a) {
    var options = _a.options, url = _a.url, method = _a.method, queryParams = _a.queryParams, body = _a.body, auth = _a.auth;
    var fullUrl = makeUrl(url, options, queryParams);
    var flyRequestConfig = __assign(__assign({}, options.requestConfig), { url: fullUrl, method: method });
    if (body) {
        flyRequestConfig.body = body;
        var guessedContentTyped = guessContentType(body);
        if (guessedContentTyped) {
            flyRequestConfig.headers = __assign({ 'Content-Type': guessedContentTyped }, flyRequestConfig.headers);
        }
    }
    return ajax(injectAuthHeaders(flyRequestConfig, options, auth)).pipe(map(typeof options.mapResponse === 'function'
        ? options.mapResponse
        : function (r) { return r.response; }));
}
function httpGET(options, url, queryParams, auth) {
    return sendHttp({
        url: url,
        method: 'GET',
        options: options,
        queryParams: queryParams,
        auth: auth,
    });
}
function httpPOST(options, url, body, auth) {
    return sendHttp({
        url: url,
        method: 'POST',
        options: options,
        body: body,
        auth: auth,
    });
}
function httpPUT(options, url, body, auth) {
    return sendHttp({
        url: url,
        method: 'PUT',
        options: options,
        body: body,
        auth: auth,
    });
}
function httpPATCH(options, url, body, auth) {
    return sendHttp({
        url: url,
        method: 'PATCH',
        options: options,
        body: body,
        auth: auth,
    });
}
function httpDELETE(options, url, queryParams, auth) {
    return sendHttp({
        url: url,
        method: 'DELETE',
        options: options,
        queryParams: queryParams,
        auth: auth,
    });
}
var BaseApiBuilder = /** @class */ (function () {
    function BaseApiBuilder(options) {
        var _this = this;
        this.baseUrl = function (baseUrl) { return _this.clone(__assign(__assign({}, _this.options), { baseUrl: baseUrl })); };
        this.auth = function (auth) { return _this.clone(__assign(__assign({}, _this.options), { auth: auth })); };
        this.authHeaders = function (injectAuthHeaders) {
            return _this.clone(__assign(__assign({}, _this.options), { injectAuthHeaders: injectAuthHeaders }));
        };
        this.mapResponse = function (mapResponse) {
            return _this.clone(__assign(__assign({}, _this.options), { mapResponse: mapResponse }));
        };
        this.trailingSlash = function (trailingSlash) {
            return _this.clone(__assign(__assign({}, _this.options), { trailingSlash: trailingSlash }));
        };
        this.request = function (requestConfig) {
            return _this.clone(__assign(__assign({}, _this.options), { requestConfig: __assign(__assign({}, _this.options.requestConfig), requestConfig) }));
        };
        this.headers = function (headers) {
            var _a;
            return _this.clone(__assign(__assign({}, _this.options), { requestConfig: __assign(__assign({}, _this.options.requestConfig), { headers: __assign(__assign({}, (_a = _this.options.requestConfig) === null || _a === void 0 ? void 0 : _a.headers), headers) }) }));
        };
        this.query = function (queryParams) {
            return _this.clone(__assign(__assign({}, _this.options), { queryParams: __assign(__assign({}, _this.options.queryParams), queryParams) }));
        };
        Object.defineProperty(this, 'options', {
            value: options,
            configurable: false,
            writable: false,
            enumerable: false,
        });
    }
    return BaseApiBuilder;
}());
var HttpVerbsApiBuilder = /** @class */ (function (_super) {
    __extends(HttpVerbsApiBuilder, _super);
    function HttpVerbsApiBuilder() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.get = function (url, query) { return httpGET(_this.options, url, query); };
        _this.post = function (url, body) { return httpPOST(_this.options, url, body); };
        _this.put = function (url, body) { return httpPUT(_this.options, url, body); };
        _this.patch = function (url, body) { return httpPATCH(_this.options, url, body); };
        _this.delete = function (url, query) {
            return httpDELETE(_this.options, url, query);
        };
        return _this;
    }
    return HttpVerbsApiBuilder;
}(BaseApiBuilder));
var ApiCurriedAuthUrlBuilder = /** @class */ (function (_super) {
    __extends(ApiCurriedAuthUrlBuilder, _super);
    function ApiCurriedAuthUrlBuilder() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.get = function (auth) { return function (query) {
            return httpGET(_this.options, '', query, auth);
        }; };
        _this.post = function (auth) { return function (body) { return httpPOST(_this.options, '', body, auth); }; };
        _this.put = function (auth) { return function (body) { return httpPUT(_this.options, '', body, auth); }; };
        _this.patch = function (auth) { return function (body) { return httpPATCH(_this.options, '', body, auth); }; };
        _this.delete = function (auth) { return function (query) {
            return httpDELETE(_this.options, '', query, auth);
        }; };
        _this.clone = function (options) {
            return new ApiCurriedAuthUrlBuilder(options);
        };
        return _this;
    }
    return ApiCurriedAuthUrlBuilder;
}(BaseApiBuilder));
var UrlApiBuilder = /** @class */ (function (_super) {
    __extends(UrlApiBuilder, _super);
    function UrlApiBuilder(options) {
        var _this = _super.call(this, options) || this;
        _this.curryAuth = function () { return new ApiCurriedAuthUrlBuilder(_this.options); };
        _this.url = function (url) {
            return new UrlApiBuilder(__assign(__assign({}, _this.options), { url: _this.options.url + url }));
        };
        _this.resource = function (url) {
            return new ResourceApiBuilder(__assign(__assign({}, _this.options), { url: _this.options.url + url }));
        };
        _this.get = function (query) { return httpGET(_this.options, '', query); };
        _this.post = function (body) { return httpPOST(_this.options, '', body); };
        _this.put = function (body) { return httpPUT(_this.options, '', body); };
        _this.patch = function (body) { return httpPATCH(_this.options, '', body); };
        _this.delete = function (query) { return httpDELETE(_this.options, '', query); };
        _this.clone = function (options) { return new UrlApiBuilder(options); };
        return _this;
    }
    return UrlApiBuilder;
}(BaseApiBuilder));
var CurriedAuthResourceApiBuilder = /** @class */ (function (_super) {
    __extends(CurriedAuthResourceApiBuilder, _super);
    function CurriedAuthResourceApiBuilder(options) {
        var _this = _super.call(this, options) || this;
        _this.list = function (auth) { return function (query) {
            return httpGET(_this.options, '', query, auth);
        }; };
        _this.detail = function (auth) { return function (pk, query) {
            return httpGET(_this.options, "/" + pk, query, auth);
        }; };
        _this.create = function (auth) { return function (body) { return httpPOST(_this.options, '', body, auth); }; };
        _this.update = function (auth) { return function (pk, body) {
            return httpPUT(_this.options, "/" + pk, body, auth);
        }; };
        _this.partialUpdate = function (auth) { return function (pk, body) {
            return httpPATCH(_this.options, "/" + pk, body, auth);
        }; };
        _this.remove = function (auth) { return function (pk, query) {
            return httpDELETE(_this.options, "/" + pk, query, auth);
        }; };
        _this.removeId = function (auth) { return function (id, query) {
            return httpDELETE(__assign(__assign({}, _this.options), { mapResponse: function () { return ({ id: id }); } }), "/" + id, query, auth);
        }; };
        _this.clone = function (options) {
            return new CurriedAuthResourceApiBuilder(options);
        };
        return _this;
    }
    return CurriedAuthResourceApiBuilder;
}(BaseApiBuilder));
var ResourceApiBuilder = /** @class */ (function (_super) {
    __extends(ResourceApiBuilder, _super);
    function ResourceApiBuilder() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.curryAuth = function () { return new CurriedAuthResourceApiBuilder(_this.options); };
        _this.list = function (query) { return httpGET(_this.options, '', query); };
        _this.detail = function (pk, query) {
            return httpGET(_this.options, "/" + pk, query);
        };
        _this.create = function (body) { return httpPOST(_this.options, '', body); };
        _this.update = function (pk, body) {
            return httpPUT(_this.options, "/" + pk, body);
        };
        _this.partialUpdate = function (pk, body) {
            return httpPATCH(_this.options, "/" + pk, body);
        };
        _this.remove = function (pk, query) {
            return httpDELETE(_this.options, "/" + pk, query);
        };
        _this.removeId = function (id, query) {
            return httpDELETE(__assign(__assign({}, _this.options), { mapResponse: function () { return ({ id: id }); } }), "/" + id, query);
        };
        _this.clone = function (options) { return new ResourceApiBuilder(options); };
        return _this;
    }
    return ResourceApiBuilder;
}(HttpVerbsApiBuilder));
var ApiBuilder = /** @class */ (function (_super) {
    __extends(ApiBuilder, _super);
    function ApiBuilder() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.url = function (url) { return new UrlApiBuilder(__assign(__assign({}, _this.options), { url: url })); };
        _this.resource = function (url) { return new ResourceApiBuilder(__assign(__assign({}, _this.options), { url: url })); };
        _this.clone = function (options) { return new ApiBuilder(options); };
        return _this;
    }
    return ApiBuilder;
}(HttpVerbsApiBuilder));
function magikApi() {
    return new ApiBuilder({
        url: '',
        trailingSlash: false,
    });
}

export default magikApi;
